// Components
import { BaseImage } from 'components';

// Antd
import { Modal, Button } from 'antd';

// Interfaces
import { IBaseDialogProps } from './interfaces';

// i18n
import { useTranslation } from 'react-i18next';

// Styles
import styles from './index.module.scss';

const BaseDialog = ({
  isOpen,
  closable,
  title,
  width,
  height,
  body,
  footer,
  isUsingDefaultFooter,
  firstButtonLabel,
  isFirstButtonLoading,
  onFirstButtonClick,
  onButtonCloseClick,
  forceRender,
  firstButtonColor,
  onSecondButtonClick,
  secondButtonColor,
  secondButtonLabel,
  isSecondButtonLoading,
  isUsingSecondButton,
  isUsingButton,
  disableFirstButton,
  fullScreen,
  afterClose,
}: IBaseDialogProps) => {
  // Hook
  const { t } = useTranslation();

  return (
    <Modal
      forceRender={forceRender}
      visible={isOpen}
      centered
      footer={null}
      closable={false}
      width={fullScreen ? '100vw' : width || '90%'}
      bodyStyle={{ height: height ? height : fullScreen ? '90vh' : 'auto' }}
      afterClose={afterClose}
    >
      {/* Close Button */}
      {closable && (
        <div style={{ position: 'absolute', top: 10, right: 15, cursor: 'pointer' }} onClick={onButtonCloseClick}>
          <BaseImage isIcon isSvg icon="icon-close" />
        </div>
      )}

      {/* Header */}
      {title && <p className="font-weight-700 font-20 mt-4 mb-4 mx-0 md:mx-8">{t(title)}</p>}

      {/* Body */}
      <div className="mx-0 md:mx-8">{body ? body : <></>}</div>

      {/* Footer */}
      <div className={`${styles.footer}`}>
        {/* Otherwise, user will use new footer or both */}
        {footer ? footer : <></>}

        {/* Check if user want to use default footer */}
        {isUsingDefaultFooter && isUsingButton && (
          <>
            <Button
              type="primary"
              className={`${firstButtonColor || ''} custom-button`}
              onClick={onFirstButtonClick}
              loading={isFirstButtonLoading}
              disabled={disableFirstButton}
            >
              {firstButtonLabel && t(firstButtonLabel)}
            </Button>

            {isUsingSecondButton && (
              <Button
                type="primary"
                className={`${secondButtonColor || ''} custom-button`}
                onClick={onSecondButtonClick}
                loading={isSecondButtonLoading}
              >
                {secondButtonLabel && t(secondButtonLabel)}
              </Button>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

BaseDialog.defaultProps = {
  isUsingButton: true,
};

export { BaseDialog };
